import React, { ReactNode } from 'react';
import { components } from 'react-select';

export const ValueContainer: React.FC<any> = ({ children, ...props }) => (
  <components.ValueContainer {...props}>
    <components.Placeholder {...props} isFocused={props.isFocused}>
      {props.selectProps?.placeholder}
    </components.Placeholder>
    {React.Children.map(children, (child: ReactNode) => {
      if (!child || !(typeof child === 'object' && 'type' in child)) {
        return child;
      }
      switch (child.type) {
        case components.Placeholder:
          return null;
        case components.Input:
          if (props.selectProps?.value) {
            return child;
          }
          return React.cloneElement(child, {
            ...child.props,
            placeholder: props.selectProps?.inputPlaceholder
          });
      }
      return child;
    })}
  </components.ValueContainer>
);
